const MonitorService = {
    sendEvent: function(eventType) {

        if(window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.0') === 0) {
            return;
        }

        fetch('https://api.ipify.org?format=json')
            .then((ipResp) => ipResp.json().then((ipJson) => {
                fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({type: eventType, name: 'licitatii.binaryfusion.ro', from: ipJson}),
                }).then((response) => response.json().then((responseData) => {
                    sessionStorage.setItem('success', responseData.EventId);
                }));
            })
        );
    }

}

export default MonitorService;